import validate from "/src/client/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@20.19.33_@vue+compiler-sfc@3.5.28_cac@6.7._b7771587fed2e73b785cd7312d8df32a/node_modules/nuxt/dist/pages/runtime/validate.js";
import init_45store_45global from "/src/client/layers/base/middleware/init-store.global.ts";
import manifest_45route_45rule from "/src/client/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@20.19.33_@vue+compiler-sfc@3.5.28_cac@6.7._b7771587fed2e73b785cd7312d8df32a/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  init_45store_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-channel-nodes": () => import("/src/client/layers/base/middleware/check-channel-nodes.ts"),
  "check-downloads-url": () => import("/src/client/layers/base/middleware/check-downloads-url.ts"),
  "check-products-url": () => import("/src/client/layers/base/middleware/check-products-url.ts"),
  "check-token": () => import("/src/client/layers/base/middleware/check-token.ts"),
  "redirect-to-tab": () => import("/src/client/layers/base/middleware/redirect-to-tab.ts")
}